import React from "react"
import type { VerNotificacoesFornecedorModel } from "../models/verNotificacoesFornecedorModel"
import { VerNotificacoesFornecedorInicial } from "../models/verNotificacoesFornecedorModel"
import type { VerNotificacoesFornecedorActions } from "./verNotificacoesFornecedorActions"

type ContextValue = {
    dados: VerNotificacoesFornecedorModel
    dispatch: React.Dispatch<VerNotificacoesFornecedorActions>
    erroCarregamento: string | null
    pesquisar: () => Promise<void>
    excluir: (id: number) => Promise<void>
}

export const VerNotificacoesFornecedorContext = React.createContext<ContextValue>({
    dados: VerNotificacoesFornecedorInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    pesquisar: async () => undefined,
    excluir: async () => undefined,
})
